import React from 'react';
import { pathwaySteps } from '../data/site';
import { SectionCta } from './SectionCta';
export function ProblemSection() {
  return <section className="w-full bg-cream px-5 py-14 sm:px-6 sm:py-20" data-id="element-247" data-mp="2ltwahol6icuz">
      <div className="mx-auto max-w-3xl" data-id="element-248" data-mp="30hhbncyhu209">
        <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-249" data-mp="30iis5wya3gpd">The real problem</p>
        <h2 className="mt-3 font-serif text-[28px] font-bold leading-[1.12] text-navy sm:text-4xl" data-id="element-250" data-mp="2voeg4za5oihf">
          From clinical uncertainty to a clearer decision path
        </h2>

        <div className="mt-6 space-y-4 text-[16px] leading-relaxed text-navy/75 sm:text-[17px]" data-id="element-251" data-mp="35fr95u7oxep1">
          <p data-id="element-252" data-mp="3jfjvldc6p8r7">
            The problem isn’t that menopause information is unavailable. The problem is that it’s{' '}
            <strong className="font-bold text-navy" data-id="element-253" data-mp="3ehs7kuenu6sa">everywhere</strong>.
          </p>
          <p data-id="element-254" data-mp="1p2kk9weu70pq">
            You may need to review recommendations from multiple organizations, papers, clinical
            references, dosing information, risk considerations, contraindications, follow-up
            recommendations and patient communication guidance.
          </p>
          <p className="border-l-2 border-gold pl-4 font-serif text-[19px] font-bold italic leading-snug text-navy sm:text-2xl" data-id="element-255" data-mp="od9g06e122ak">
            And meanwhile… your patient is sitting in front of you waiting for a decision.
          </p>
          <p data-id="element-256" data-mp="x6mm6a13r0el">
            Menopause Decision Desk™ was created to solve exactly this problem. Instead of starting with
            hundreds of pages of information — start with the decision.
          </p>
        </div>

        <div className="mt-9 rounded-2xl border border-navy/10 bg-white p-5 sm:p-7" data-id="element-257" data-mp="1c1sq8rgn0p5a">
          <p className="mb-5 text-center text-[11px] font-bold uppercase tracking-[0.14em] text-navy/55" data-id="element-258" data-mp="1bzy4xc1gev0o">
            The decision sequence
          </p>
          <ol className="grid grid-cols-2 gap-2.5 sm:grid-cols-3 lg:grid-cols-6" data-id="element-259" data-mp="3du767kzmfjj2">
            {pathwaySteps.map((step, i) => <li key={step} className="flex flex-col items-center justify-center gap-1 rounded-xl bg-sand px-2 py-3.5 text-center" data-id="element-260" data-mp="3hv0uifgz70ch" data-mpi={i}>
                <span className="font-serif text-[13px] font-bold text-gold" data-id="element-261" data-mp="k2h6mqaqza76">{String(i + 1).padStart(2, '0')}</span>
                <span className="text-[12.5px] font-bold uppercase tracking-[0.06em] text-navy" data-id="element-262" data-mp="y29xqmq6rsfo">{step}</span>
              </li>)}
          </ol>
        </div>

        <SectionCta headline="Start your next consultation from the decision, not from page one." label="Get my Decision Desk™" data-id="element-263" data-mp="17y38c0kchbut" />
      </div>
    </section>;
}